import React, {FC} from 'react';
import VodSingleContent from './components/VodSingleContent';
import PaywallChecker from '@src/Umbraco/Components/PaywallChecker/PaywallChecker';
import {RouteComponentProps} from '@reach/router';
import {useVodSinglePageLogic} from './hooks/useVodSinglePageLogic';

const VodSinglePage: FC<RouteComponentProps<{id: string}>> = () => {
  const logic = useVodSinglePageLogic();

  console.log('VodSinglePage logic vodItem:', logic.vodItem);

  return (
    <PaywallChecker
      accessType={logic.vodItem?.accessType}
      paywall={logic.vodItem?.paywall}
      trackingData={logic.trackingData}>
      <VodSingleContent
        vodItem={logic.vodItem}
        loading={logic.loading}
        t={logic.t}
        isMobile={logic.isMobile}
        calculateWidth={logic.calculateWidth}
        listCategory={logic.listCategory}
        bookmarkItem={logic.bookmarkItem}
        updateBookMark={logic.handleFav}
        onWatchClick={logic.onWatchClick}
        openTrailer={logic.openTrailer}
        shareContent={logic.handleShare}
        isOpenDialogShare={logic.isOpenDialogShare}
        setIsOpenDialogShare={logic.setIsOpenDialogShare}
        linkToShare={logic.linkToShare}
        setLinkToShare={logic.setLinkToShare}
      />
    </PaywallChecker>
  );
};

export default VodSinglePage;
